var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoftOneDrive = function SvgMicrosoftOneDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0364B8",
    d: "m9.626 8.558 4.2 2.514 2.501-1.053a4.049 4.049 0 0 1 1.885-.321A6.25 6.25 0 0 0 6.936 7.814L7 7.812a4.975 4.975 0 0 1 2.626.746Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M9.627 8.557v.001A4.976 4.976 0 0 0 7 7.813l-.064.001a4.998 4.998 0 0 0-4.038 7.857l3.703-1.559 1.646-.692 3.664-1.542 1.914-.806-4.198-2.515Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1490DF",
    d: "M18.212 9.698a4.048 4.048 0 0 0-1.885.322l-2.502 1.052.726.435 2.378 1.424 1.037.622 3.548 2.125a4.063 4.063 0 0 0-3.302-5.98Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#28A8EA",
    d: "m17.966 13.553-1.037-.622-2.378-1.424-.726-.435-1.914.806-3.664 1.542-1.646.692-3.703 1.559A4.993 4.993 0 0 0 7 17.813h10.938a4.061 4.061 0 0 0 3.576-2.135l-3.548-2.125Z"
  })));
};
export default SvgMicrosoftOneDrive;